/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  Grid, Card, TextField, Tooltip, IconButton,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import { Controller } from 'react-hook-form';
import ComponentSelectInput from '../../../../Common/ComponentSelectInput';
import ComponentTextInput from '../../../../Common/ComponentTextinput/ComponentTextInput';
import {
  BillingInfoForm, CustomerInformationForm, GetCustomerByIdPayload, IBillingInformation,
} from '../../utils/types';
import './StyleMainTab.scss';
import { RootState } from '../../../../redux/rootState';
import AddCustomerModal from '../../../../Common/AddCustomerModal';
import {
  getBillPinCodeDetailsStart, getCustomerByIdStart, removeBillPinCodeDetails, resetBillCityStateSuggestion,
} from '../../redux/addCustomerSlice';
import CustomCheckbox from '../../../../Common/ComponentCustomCheckBox';
import { CUSTOMER_BILLING_INFO_KEY } from '../../../AnalystScreen/AnalystAddScreen/utils/constants';
import { stripCustPrefix } from '../../../../utils/CommonFunctions';
import { RHFAutocompleteFieldWithState } from '../../../../Common/ComponentAutoSelectWithState';

export default function BillingInformation({
  control, setValue, getValues, watch,
}: IBillingInformation): JSX.Element {
  const { countries, countryBasedStates } = useSelector((state: RootState) => state.masterDataReducer);
  const [showModal, setShowModal] = useState(false);
  const [enableSetState, setEnableSetState] = useState(false);
  const dispatch = useDispatch();
  const {
    selectedCustomerDetails, otherCustomerdetails, billingPinCodeDetails, billCityStateSuggestions,
  } = useSelector((state: RootState) => state.addCustomerReducer);
  const billingZip = watch(BillingInfoForm.billingZip);
  const billingState = watch(BillingInfoForm.billingState);
  const billingCountry = watch(BillingInfoForm.billingCountry);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [inputValue, setInputValue] = React.useState('');

  const stateList = useMemo(() => {
    if (countryBasedStates && billingCountry) {
      const countryState = countryBasedStates.find((item) => item?.Country === billingCountry);
      return countryState ? countryState?.States?.map((item) => ({ Value: item, Text: item })) : [];
    }
    return [];
  }, [countryBasedStates, billingCountry]);

  const handleTabCell = (customer_id: string) => {
    setShowModal(false);
    const payload: GetCustomerByIdPayload = {
      customerId: customer_id,
      otherCustomer: true,
      billingAddressCustId: true,
    };
    dispatch(getCustomerByIdStart(payload));
    setValue(BillingInfoForm.billToCorporate, stripCustPrefix(customer_id));
  };

  const sameAsCompanyAdd = watch(BillingInfoForm.sameCompanyAddress);
  const creditCardCB = watch(BillingInfoForm.creditCardRequired);
  const approvedForPoCB = watch(BillingInfoForm.approvedPO);
  const billToCorporate = watch(BillingInfoForm.billToCorporate);

  const disabled = useMemo(() => sameAsCompanyAdd || (billToCorporate?.length > 0), [sameAsCompanyAdd, billToCorporate]);

  useEffect(() => {
    if (creditCardCB) {
      setValue(BillingInfoForm.approvedPO, false);
    }
  }, [creditCardCB]);
  useEffect(() => {
    if (approvedForPoCB) {
      setValue(BillingInfoForm.creditCardRequired, false);
    }
  }, [approvedForPoCB]);

  useEffect(() => {
    if (sameAsCompanyAdd) {
      setValue(BillingInfoForm.billToCorporate, '');
    }
  }, [sameAsCompanyAdd]);

  // useEffect(() => {
  //   if (!sameAsCompanyAdd) {
  //     if (billingZip && billingZip?.length >= 5) {
  //       dispatch(removeBillPinCodeDetails());
  //       setValue(BillingInfoForm.billingState, '');
  //       // setValue(BillingInfoForm.billingCity, '');
  //       const queryPayload = {
  //         pinCode: billingZip,
  //         countryCode: getValues(BillingInfoForm.billingCountry),
  //         key: CUSTOMER_BILLING_INFO_KEY,
  //       };
  //       dispatch(getBillPinCodeDetailsStart(queryPayload));
  //     } else if (billingZip?.length < 5) {
  //       dispatch(removeBillPinCodeDetails());
  //       setValue(BillingInfoForm.billingState, '');
  //     }
  //   }
  // }, [billingZip, billingCountry]);

  const handleBillingZipChange = (_e: string, text: string) => {
    setEnableSetState(true);
    if (text && text?.length >= 5) {
      dispatch(removeBillPinCodeDetails());
      dispatch(resetBillCityStateSuggestion());
      setValue(BillingInfoForm.billingState, '');
      // setValue(CustomerInformationForm.COMPANY_OTHER_CITY, '');
      const queryPayload = {
        pinCode: text,
        countryCode: getValues(BillingInfoForm.billingCountry),
        key: CUSTOMER_BILLING_INFO_KEY,
      };
      dispatch(getBillPinCodeDetailsStart(queryPayload));
    } else if (text?.length < 5) {
      dispatch(removeBillPinCodeDetails());
      dispatch(resetBillCityStateSuggestion());
      setValue(BillingInfoForm.billingState, '');
      // setValue(CustomerInformationForm.COMPANY_OTHER_CITY, '');
    }
  };
  useEffect(() => {
    if (selectedCustomerDetails?.BillingInformation?.ZipCode
        && selectedCustomerDetails?.BillingInformation?.ZipCode?.length >= 5 && !enableSetState) {
      dispatch(removeBillPinCodeDetails());
      dispatch(resetBillCityStateSuggestion());
      // setValue(CustomerInformationForm.companyState, '');
      // setValue(CustomerInformationForm.COMPANY_OTHER_CITY, '');
      const queryPayload = {
        pinCode: selectedCustomerDetails?.BillingInformation?.ZipCode,
        countryCode: getValues(BillingInfoForm.billingCountry),
        key: CUSTOMER_BILLING_INFO_KEY,
      };
      dispatch(getBillPinCodeDetailsStart(queryPayload));
    }
    // handleCompanyZipChange('', selectedCustomerDetails?.CompanyInformation?.ZipCode || '');
  }, [selectedCustomerDetails?.BillingInformation]);
  const handleBillingCountryChange = (text: string) => {
    dispatch(removeBillPinCodeDetails());
    setValue(BillingInfoForm.billingCountry, text);
    setValue(BillingInfoForm.billingZip, '');
    handleBillingZipChange('', '');
  };

  useEffect(() => {
    if (billingPinCodeDetails?.City && billingZip && enableSetState) {
      setValue(BillingInfoForm.billingState, billingPinCodeDetails.StateName);
    }
  }, [billingPinCodeDetails]);

  useEffect(() => {
    if (otherCustomerdetails?.CompanyInformation) {
      setValue(BillingInfoForm.billingAddress, otherCustomerdetails?.CompanyInformation?.Address);
      setValue(BillingInfoForm.billingOptionalAddress, otherCustomerdetails?.CompanyInformation?.OptionalAddress);
      setValue(BillingInfoForm.billingCountry, otherCustomerdetails?.CompanyInformation?.CountryCode);
      setValue(BillingInfoForm.billingZip, otherCustomerdetails?.CompanyInformation?.ZipCode);
      setValue(BillingInfoForm.billingState, otherCustomerdetails?.CompanyInformation?.StateName);
      setValue(BillingInfoForm.billingCity, otherCustomerdetails?.CompanyInformation?.CityName);
    }
  }, [otherCustomerdetails]);

  const handleChange = (checked: boolean) => {
    if (checked) {
      setValue(BillingInfoForm.billingAddress, getValues(CustomerInformationForm.address));
      setValue(BillingInfoForm.billingOptionalAddress, getValues(CustomerInformationForm.companyAddress));
      setValue(BillingInfoForm.billingCountry, getValues(CustomerInformationForm.companyCountry));
      setValue(BillingInfoForm.billingZip, getValues(CustomerInformationForm.companyZip));
      setValue(BillingInfoForm.billingState, getValues(CustomerInformationForm.companyState));
      setValue(BillingInfoForm.billingCity, getValues(CustomerInformationForm.COMPANY_OTHER_CITY));
    } else {
      setValue(BillingInfoForm.billingAddress, '');
      setValue(BillingInfoForm.billingOptionalAddress, '');
      setValue(BillingInfoForm.billingCountry, 'US');
      setValue(BillingInfoForm.billingZip, '');
      setValue(BillingInfoForm.billingState, '');
      setValue(BillingInfoForm.billingCity, '');
      setInputValue(''); // Reset input value when unchecked
      dispatch(resetBillCityStateSuggestion());
    }
  };

  const handleOnChange = (text: string, onChange: (event: string) => void, value: string) => {
    if (value?.length > 0) {
      return;
    }
    onChange('');
  };

  useEffect(() => {
    if (selectedCustomerDetails?.BillingInformation && enableSetState === false) {
      setInputValue(selectedCustomerDetails?.BillingInformation?.CityName || '');
    }
  }, [selectedCustomerDetails]);

  return (
    <Card>
      <div className="customerInfo_container">
        <div className="customerInfo">
          Billing Information
        </div>
        <div className="billing-checkbox customer_info_checkbox">
          <div className="customer_info_header_checkbox">
            <CustomCheckbox
              name={BillingInfoForm.sameCompanyAddress}
              control={control}
              handleChange={handleChange}
              label="Same as Company Address"
            />
            <CustomCheckbox
              name={BillingInfoForm.creditCardRequired}
              control={control}
              label="Credit Card Required"
            />
            <CustomCheckbox
              name={BillingInfoForm.approvedPO}
              control={control}
              label="Approved for PO"
            />
          </div>
          <div className="dropdown_container mob-pt-3">
            <div className="dropdown_side_label">
              <Controller
                name={BillingInfoForm.billToCorporate}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    size="small"
                    placeholder="Bill to Corporate"
                    value={value}
                    onClick={() => setShowModal(true)}
                    onChange={(text) => handleOnChange(text.currentTarget.value, onChange, value)}
                    disabled={disabled && (billToCorporate?.length === 0)}
                    InputProps={{
                      endAdornment: !disabled ? (
                        <Tooltip title="Search here..">
                          <IconButton onClick={() => setShowModal(true)}>
                            <SearchIcon />
                          </IconButton>
                        </Tooltip>
                      ) : '',
                    }}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="customerInfo_main_container">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className="div_label_text">
              <label className="label_Style_Customer">Address </label>
              <ComponentTextInput
                control={control}
                isDisable={disabled}
                inputProps={{ maxLength: 200 }}
                className="nonCapitalizeField"
                name={BillingInfoForm.billingAddress}
                id={BillingInfoForm.billingAddress}
                size="small"
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className="div_label_text">
              <label className="label_Style_Customer">Address(Optional)</label>
              <ComponentTextInput
                control={control}
                isDisable={disabled}
                inputProps={{ maxLength: 200 }}
                className="nonCapitalizeField"
                name={BillingInfoForm.billingOptionalAddress}
                id={BillingInfoForm.billingOptionalAddress}
                size="small"
              />
            </div>
          </Grid>
          {sameAsCompanyAdd ? (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              <div className="div_label_text">
                <label className="label_Style_Customer">Country</label>
                <ComponentTextInput
                  control={control}
                  isDisable={disabled}
                  inputProps={{ maxLength: 200 }}
                  className="nonCapitalizeField"
                  name={BillingInfoForm.billingCountry}
                  id={BillingInfoForm.billingCountry}
                  size="small"
                />
              </div>
            </Grid>
          ) : (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              <div className="div_label_text">
                <label className="label_Style_Customer">Country</label>
                <ComponentSelectInput
                  name={BillingInfoForm.billingCountry}
                  control={control}
                  disabled={disabled}
                  size="small"
                  entries={countries}
                  // handleChange={() => {
                  //   setValue && setValue(BillingInfoForm.billingZip, '');
                  // }}
                  handleChange={(text: string) => {
                    setValue && setValue(BillingInfoForm.billingZip, '');
                    setValue && setValue(BillingInfoForm.billingCity, '');
                    setInputValue('');
                    handleBillingCountryChange(text);
                  }}
                />
              </div>
            </Grid>
          )}
          {sameAsCompanyAdd ? (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              <div className="div_label_text">
                <label className="label_Style_Customer">Zip</label>
                <ComponentTextInput
                  control={control}
                  isDisable={disabled}
                  inputProps={{ maxLength: 200 }}
                  className="nonCapitalizeField"
                  name={BillingInfoForm.billingZip}
                  id={BillingInfoForm.billingZip}
                  size="small"
                />
              </div>
            </Grid>
          ) : (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              <div className="div_label_text">
                <label className="label_Style_Customer">Zip</label>
                <ComponentTextInput
                  control={control}
                  isDisable={disabled}
                  inputProps={{ maxLength: 10 }}
                  className="nonCapitalizeField"
                  name={BillingInfoForm.billingZip}
                  id={BillingInfoForm.billingZip}
                  size="small"
                  // handleChange={() => {
                  //   setValue && setValue(BillingInfoForm.billingCity, '');
                  //   setValue && setValue(BillingInfoForm.BILLING_OTHER_CITY, '');
                  //   setInputValue('');
                  // }}
                  handleChange={(name: string, text: string) => {
                    setValue && setValue(BillingInfoForm.billingCity, '');
                    setInputValue('');
                    handleBillingZipChange(name, text);
                  }}
                />
              </div>
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className="div_label_text">
              <label className="label_Style_Customer">State</label>
              {/* <ComponentTextInput
                control={control}
                name={BillingInfoForm.billingState}
                id={BillingInfoForm.billingState}
                isDisable
                size="small"
              /> */}
              <ComponentSelectInput
                name={BillingInfoForm.billingState}
                disabled={disabled || !!billingZip}
                control={control}
                size="small"
                entries={stateList}
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                handleChange={() => {
                  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                  setValue && setValue(BillingInfoForm.billingCity, '');
                  setInputValue('');
                  dispatch(resetBillCityStateSuggestion());
                }}
              />
            </div>
          </Grid>
          {disabled ? (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              <div className="div_label_text">
                <label className="label_Style_Customer">City</label>
                <ComponentTextInput
                  control={control}
                  isDisable={disabled}
                  inputProps={{ maxLength: 200 }}
                  className="nonCapitalizeField"
                  name={BillingInfoForm.billingCity}
                  id={BillingInfoForm.billingCity}
                  size="small"
                />
              </div>
            </Grid>
          ) : (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
              <div className="div_label_text">
                <label className="label_Style_Customer">City</label>
                {/* {renderCityInput() ? (
                  <RHFAutocompleteField
                    options={citySuggestions || []}
                    control={control}
                    disabled={disabled}
                    name={BillingInfoForm.BILLING_OTHER_CITY}
                    setValue={setValue}
                  />
                )
                  : (
                    <ComponentSelectInput
                      name={BillingInfoForm.billingCity}
                      defaultValue=""
                      control={control}
                      disabled={disabled}
                      size="small"
                      entries={billingPinCodeDetails?.City ? [...billingPinCodeDetails.City, otherCity] : []}
                    />
                  )} */}
                <RHFAutocompleteFieldWithState
                  // eslint-disable-next-line no-nested-ternary
                  options={billingZip ? billingPinCodeDetails?.City ? [...billingPinCodeDetails.City] : [] : billCityStateSuggestions || []}
                  companyZip={billingZip}
                  control={control}
                  name={BillingInfoForm.billingCity}
                  id={BillingInfoForm.billingCity}
                  setValue={setValue}
                  companyState={billingState}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  disabled={disabled}
                  isBilling
                />
              </div>
            </Grid>
          )}
        </Grid>
      </div>
      {showModal && (
      <AddCustomerModal
        show={showModal}
        setOpenFrom={() => setShowModal(false)}
        handleTabCell={handleTabCell}
      />
      )}
    </Card>
  );
}
